import { ImageContentGridBottom } from "../../../../modules/content/components/ImageContentGridBottom/ImageContentGridBottom";
import { ImageContentGridTop } from "../../../../modules/content/components/ImageContentGridTop/ImageContentGridTop";
import { StratosCommonContent } from "../../../../modules/content/components/StratosCommonContent/StratosCommonContent";
import { StratosSection } from "../../../../modules/content/components/StratosSection/StratosSection";
import type { IImageContentGridBlockProps } from "./ImageContentGridBlock.props";

export const ImageContentGridBlock = (props: IImageContentGridBlockProps) => {
  const {
    alignment,
    anchorId,
    buttons,
    description,
    eyebrow,
    heading,
    items,
    parentClass,
    spacing,
    variant,
  } = props;
  if (!items?.length) return null;
  return (
    <StratosSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-10 md:gap-14">
        <StratosCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        {variant === "image-bottom" ? (
          <ImageContentGridBottom {...props} />
        ) : (
          <ImageContentGridTop {...props} />
        )}
      </div>
    </StratosSection>
  );
};

ImageContentGridBlock.displayName = "Block::ImageContentGridBlock";
